import useInteraction from "./Interaction.hook";

export default useInteraction;
